import { BUTTON_TYPES } from '@abiglobalhealth/go-types'
import { useTranslation } from 'react-i18next'

import AlertIcon from '@/assets/icons/warn-alert.svg'
import { Button } from '@/components/Button'

interface ExitLogicModalProps {
  handleUndo: () => void
  handleEnd: () => void
}

export const ExitLogicModal = ({ handleUndo, handleEnd }: ExitLogicModalProps) => {
  const { t } = useTranslation()

  return (
    <div className="animate-fade-in fixed top-0 left-0 z-30 flex h-full w-full flex-col items-center justify-center bg-black/50 p-4">
      <div className="flex w-full max-w-sm flex-col gap-6 rounded-2xl bg-white p-6">
        <img src={AlertIcon} alt="Alert icon" className="mx-auto h-15 w-15" />

        <h5 className="text-center font-bold">{t('exit_logic.denied.title')}</h5>
        <p className="text-center">{t('exit_logic.denied.description')}</p>

        <div className="flex w-full items-center justify-center gap-8">
          <Button onClick={handleUndo} type={BUTTON_TYPES.OUTLINED} customClassName="rounded-full" hasShadow={false}>
            {t('button.undo')}
          </Button>
          <Button onClick={handleEnd} type={BUTTON_TYPES.OUTLINED} customClassName="rounded-full" hasShadow={false}>
            {t('button.end')}
          </Button>
        </div>
      </div>
    </div>
  )
}
